import { ReactNode } from 'react';
import { Box } from '@mui/material';

export const SubtitleContainer = ({ children, bgColor }: { children: ReactNode; bgColor: string }) => (
    <Box
        sx={{
            bgcolor: bgColor,
            borderRadius: '8px',
            mt: '4px',
            py: 1.5,
            px: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}
    >
        {children}
    </Box>
);
